import { classNames, isEnumValid, isFunction } from '@philips-internal/oswald-ui-utils';
import { Heading } from '../heading/heading.js';
import { HeadingSectionHeaderBackgroundColor } from './heading-section-constants.js';
import { HeadingSectionProperties } from './heading-section-types.js';
class HeadingSection extends Heading {
    constructor() {
        super(...arguments);
        this.onHeaderClick = (event, callback) => {
            if (!isFunction(callback)) {
                return;
            }
            event.stopPropagation();
            callback();
        };
    }
    getHeaderClassName(baseClass) {
        const { headerBackgroundColor = HeadingSectionProperties.headerBackgroundColor.defaultValue, showCollapseButton, } = this.props;
        return classNames({
            [`${baseClass}`]: true,
            [`${baseClass}--${headerBackgroundColor}`]: isEnumValid(HeadingSectionHeaderBackgroundColor, headerBackgroundColor),
            [`${baseClass}--collapsible`]: Boolean(showCollapseButton),
        });
    }
    render() {
        return null;
    }
}
export { HeadingSection, };
//# sourceMappingURL=heading-section.js.map